<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Project Filtering Settings</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select 
                  v-model="editedItem.project_id"
                  :items="indexData.projects" 
                  item-text="name" 
                  item-value="id" 
                  label="Project name"
                  ></v-select>
                  <v-select 
                  v-model="editedItem.filtering_parameter_id" 
                  :items="indexData.projectFilteringParams" 
                  item-text="name" 
                  item-value="id"
                  label="Filtering parameter nane"
                  ></v-select>
                  <v-select 
                  v-model="editedItem.comparision_operator_id"
                  :items="indexData.comparisionOperators"   
                  item-text="symbol" 
                  item-value="id" 
                  label="Comparision operator name"
                  ></v-select>
                  <v-text-field v-model="editedItem.value" label="Value"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.project_id }}</td>
        <td class="text-xs-center">{{ props.item.filtering_parameter_id }}</td>
        <td class="text-xs-center">{{ props.item.comparision_operator_id }}</td>
        <td class="text-xs-center">{{ props.item.value }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'project-filtering-setting',
      headers: [
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Project Name',
          align: 'center',
          sortable: false,
          value: 'project_id'
        },
        {
          text: 'PFP Name',
          align: 'center',
          sortable: false,
          value: 'filtering_parameter_id'
        },
        {
          text: 'CO Name',
          align: 'center',
          sortable: false,
          value: 'comparision_operator_id'
        },
        {
          text: 'PFP Value',
          align: 'center',
          sortable: false,
          value: 'value'
        },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: { 
        project_id: '',
        filtering_parameter_id: '',
        comparision_operator_id: '',
        value:'',
      },
      defaultItem: {
        created_by: '',  
        project_id: '',
        filtering_parameter_id: '',
        comparision_operator_id: '',
        value:'',

        project:{
          details: '',
        },

        pfp:{
          symbol: ''
        },

        comparision_operator:{
          name: ''
        }

      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'Create' : 'Edit'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        // console.log(item)
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.datas.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.datas.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        // console.log(this.editedItem);
        if (this.editedIndex > -1) {
          // console.log(this.editedItem);
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>